//
// Manuelle Zahleneingabe (Zählerstände etc.) mit deutschem Dezimalkomma.
//
// <input type="number"> ist Browser-/Locale-abhängig: je nach Browser wird
// ein eingetipptes Komma stillschweigend verschluckt ("123,45" -> 12345,
// Faktor 1000!) oder das Feld meldet einen leeren Wert. Dezimalfelder
// daher als type="text" inputmode="decimal" bauen und hier validieren
// und parsen — Komma UND Punkt sind als Dezimaltrenner erlaubt,
// Tausendertrenner nicht (zwei Trennzeichen -> ungültig statt falsch).
//

// Validator im vuelidate-Stil: leer ist gültig (dafür ist `required`
// zuständig), sonst eine Zahl mit höchstens einem Dezimaltrenner.
export function isDecimalInput (value) {
  if (value === null || value === undefined || value === '') return true
  if (typeof value === 'number') return isFinite(value)
  return /^-?(\d+([.,]\d+)?|[.,]\d+)$/.test(String(value).trim())
}

// Eingabe-String -> Number (oder null bei leer). Vorher isDecimalInput prüfen.
export function parseDecimalInput (value) {
  if (typeof value === 'number') return value
  if (value === null || value === undefined) return null
  const trimmed = String(value).trim()
  if (trimmed === '') return null
  return Number(trimmed.replace(',', '.'))
}
